import { Banner } from 'components/Banner';

import { NotifyAdminSuccessBanner } from '../NotifyAdminSuccessBanner';

import { StyledButton, StyledContainer } from './styles';

type Props = {
  isSuccess?: boolean;
  isVisible: boolean;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: VoidFunction;
  isLoading?: boolean;
};

export const LowQuotaNotificationBanner = ({
  isSuccess = false,
  isVisible,
  title,
  description,
  buttonText,
  onButtonClick,
  isLoading,
}: Props) => {
  if (isSuccess) {
    return <NotifyAdminSuccessBanner />;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <StyledContainer>
      <Banner title={title} description={description}>
        {buttonText ? (
          <StyledButton variant="ghost" onClick={onButtonClick} disabled={isLoading}>
            {buttonText}
          </StyledButton>
        ) : null}
      </Banner>
    </StyledContainer>
  );
};
